import { CustomerFeature, customerHasFeature } from 'domain/Customer'
import { get, isFunction } from 'lodash-es'
import { inject, observer } from 'mobx-react'
import { Component, ReactNode } from 'react'
import { AuthStore } from 'service/Auth'
import { hasRoles, Role } from 'service/roles'
import { RootStore } from 'service/RootStore'

interface IAccessInject {
  authStore: AuthStore
}

interface IAccessProps extends Partial<IAccessInject> {
  roles: Role[]
  feature?: CustomerFeature
  children: ReactNode | ((props: { hasAccess: boolean }) => ReactNode)
}

export class LeanAccess extends Component<IAccessProps> {
  get hasAccess(): boolean {
    const { authStore, feature, roles } = this.props
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    const { user, customer } = authStore.state

    return hasRoles(user, roles) && (!feature || customerHasFeature(customer, feature))
  }

  render() {
    const { children, authStore, feature } = this.props
    if (!get(authStore, 'state.user') || (feature && !get(authStore, 'state.customer'))) {
      return null
    }

    if (isFunction(children)) {
      return children({ hasAccess: this.hasAccess })
    }
    return this.hasAccess ? children : null
  }
}

const injector = inject(
  (ctx: RootStore): IAccessInject => ({
    authStore: ctx.authStore,
  })
)

export const Access = injector(observer(LeanAccess))
